import React from "react";
import clsx from "clsx";
import "./message-layout.styles.scss";

import { memoize } from "../../../utils/memoize";
import { hhmm } from "../../../utils/date/hhmm";

import type {
	MessageContentType,
	IUIMessageSender,
	IUIMessageStatus,
	IUIMessageReaction,
} from "../../../shared/types";

import type { MessageLayoutProps, MessageLayoutType } from "../types";
import { SelectableItem } from "../../SelectableItem";
import zCBLAnimationModule from "../../../core/engines";

import { Avatar } from "../../Avatar";
import { SnapEffectContainer } from "../../../core/animations";
import { useChatBoxViewContext } from "../../../contexts";

const BlockName = "message-layout";
const ClassNames = {
	Block: `${BlockName}`,
	Modifiers: {
		Frame: "--frame",
		NoFrame: "--no-frame",
		FromMe: "--from-me",
	},
	Elements: {
		Avatar: `${BlockName}__avatar`,
		SenderName: `${BlockName}__sender-name`,
		Frame: `${BlockName}__frame`,
		NoFrame: `${BlockName}__no-frame`,
		Content: `${BlockName}__content`,
		SendTime: `${BlockName}__send-time`,
	},
} as const;

export type MessageLayoutComponent<
	T extends MessageLayoutType = "Frame",
	MC extends MessageContentType = any,
> = React.FC<MessageLayoutProps<T, MC>> & {
	ClassNames: typeof ClassNames;
};

export const MessageLayout = (<
	T extends MessageLayoutType = "Frame",
	MC extends MessageContentType = any,
>(
	props: MessageLayoutProps<T, MC>,
) => {
	const {
		layoutType = "Frame",
		showStatus = true,
		showSender = true,
		showSendTime = true,
		isFromMe,
	} = props;

	const { fromUidInfo } = useChatBoxViewContext();

	//TODO: get sender info, status info, reaction info...
	// const senderInfo: IUIMessageSender = memoize(
	// 	() => ({
	// 		uid: "123",
	// 		name: "John Doe",
	// 		displayName: "John Doe",
	// 		avatarUrl: "https://via.placeholder.com/150",
	// 	}),
	// 	[],
	// );
	// const statusInfo: IUIMessageStatus = memoize(
	// 	() => ({
	// 		msgId: "123",
	// 		status: "sent",
	// 	}),
	// 	[],
	// );
	// const reactionInfo: IUIMessageReaction = memoize(
	// 	() => ({
	// 		msgId: "123",
	// 		reactionId: "123",
	// 		reactions: [
	// 			{
	// 				uid: "123",
	// 				reaction: "👍",
	// 				count: 1,
	// 			},
	// 		],
	// 	}),
	// 	[],
	// );

	if (["Frame", "NoFrame"].includes(layoutType)) {
		return (
			// <zCBLAnimationModule.Component.Flipped
			// 	flipId={`msg-lo-${props.content.cliMsgId}`}
			// 	inverseFlipId={`msg-lo-${props.content.cliMsgId}`}
			// 	scale={false}
			// 	onExit={(element, index, removeElement, decisionData, animationNG) => {
			// 		debugger;
			// 		SnapEffectContainer.EventListener.dispatchEvent("animate-snap", element);
			// 		// removeElement();
			// 	}}
			// >
			<div
				className={clsx(
					MessageLayout.ClassNames.Block,
					//@ts-ignore
					MessageLayout.ClassNames.Modifiers[layoutType],
					props.className,
					isFromMe ? MessageLayout.ClassNames.Modifiers.FromMe : "",
				)}
			>
				{!isFromMe && showSender && (
					<Avatar
						className={MessageLayout.ClassNames.Elements.Avatar}
						size={32}
						src={fromUidInfo.avatarUrl}
						alt={fromUidInfo.name}
					/>
				)}
				<SelectableItem selectKey={`${props.content.cliMsgId}`}>
					{({ attrs, isSelected }) => (
						<div
							className={clsx(
								//@ts-ignore
								MessageLayout.ClassNames.Elements[layoutType],
								isSelected && layoutType === "Frame" && "--blue-selected",
							)}
							{...attrs}
						>
							{!isFromMe && (
								<div
									className={clsx(
										MessageLayout.ClassNames.Elements.SenderName,
										"truncate",
									)}
								>
									{fromUidInfo.name}
								</div>
							)}
							<div className={MessageLayout.ClassNames.Elements.Content}>
								{/* @ts-ignore */}
								{props.children()}
							</div>
							{showSendTime && (
								<div className={MessageLayout.ClassNames.Elements.SendTime}>
									{memoize(
										() => hhmm(props.content.sendDttm),
										[props.content.sendDttm],
									)}
								</div>
							)}
						</div>
					)}
				</SelectableItem>
			</div>
			// </zCBLAnimationModule.Component.Flipped>
		);
	}

	// if (layoutType === "Custom") {
	// 	return typeof props.children === "function" ? props.children(props) : null;
	// }

	return null;
}) as MessageLayoutComponent;
MessageLayout.ClassNames = ClassNames;
